import { useQuery } from "@tanstack/vue-query"

export type ListPermissionsResponseItem = {
  label: string
  value: string
}

export const listPermissions = async () => {
  const { body } = await api.get<
    ListPermissionsResponseItem[]
  >(`/users/permissions/`)
  return body
}

export const usePermissions = () => {
  const queryReturn = useQuery({
    queryKey: [PERMISSIONS_QUERY_KEY] as const,
    queryFn: listPermissions,
  })

  const getPermissionLabel = (
    permissionValue: ListPermissionsResponseItem["value"]
  ) => {
    return (
      queryReturn?.data.value?.find(
        (permission) => permission.value === permissionValue
      )?.label ?? ""
    )
  }

  return {
    ...queryReturn,
    getPermissionLabel,
  }
}
